module.exports = __webpack_public_path__ + "img/icon_002.955a7a2.png";